import { render, staticRenderFns } from "./SideNavigationBar.vue?vue&type=template&id=15b84d33&scoped=true"
import script from "./SideNavigationBar.vue?vue&type=script&lang=js"
export * from "./SideNavigationBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b84d33",
  null
  
)

export default component.exports